import React, { createContext, useContext, useState } from 'react';

// Create a context for dashboard filters
const DashboardFilterContext = createContext();

// Custom hook to use the dashboard filter context
export const useDashboardFilters = () => {
    const context = useContext(DashboardFilterContext);
    if (!context) {
        throw new Error('useDashboardFilters must be used within a DashboardFilterProvider');
    }
    return context;
};

// Dashboard Filter Provider component
export const DashboardFilterProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        dateRange: { from: null, to: null },
        company: 'all',
        // Add more filter fields as needed
    });

    const updateFilters = (newFilters) => {
        setFilters(prev => ({ ...prev, ...newFilters }));
    };

    const value = {
        filters,
        updateFilters
    };

    return (
        <DashboardFilterContext.Provider value={value}>
            {children}
        </DashboardFilterContext.Provider>
    );
};